import FirstSection from "./sections/FirstSection";

export default function App() {
  return (
    <div className="App">
      <div className="mq-digital">
        <FirstSection />
      </div>
    </div>
  );
}
